// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-list-badge-column {
	font-size: .8em;
	line-height: 1;
	max-width: 9em;
	min-width: 9em;
}
`, "",{"version":3,"sources":["webpack://./src/views/task/style.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,cAAc;CACd,cAAc;CACd,cAAc;AACf","sourcesContent":[".task-list-badge-column {\r\n\tfont-size: .8em;\r\n\tline-height: 1;\r\n\tmax-width: 9em;\r\n\tmin-width: 9em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
